/** Icons & inspiration thumbnails for Kids Girl — 4-12 years (`public/assets/kids/girl/4-12 year/`) */
const KIDS_GIRL_412_BASE = `${process.env.PUBLIC_URL || ''}/assets/kids/girl/4-12 year`;

function kidsGirl412Asset(filename) {
  return `${KIDS_GIRL_412_BASE}/${filename}`;
}

export const KIDS_GIRL_412_CATEGORY_PREVIEW = kidsGirl412Asset('Dress.png');

export const KIDS_GIRL_412_ICON_BY_VALUE = {
  dress: kidsGirl412Asset('Dress.png'),
  frock: kidsGirl412Asset('Dress.png'),
  top: kidsGirl412Asset('Top.png'),
  shirt: kidsGirl412Asset('shirt.png'),
  skirt: kidsGirl412Asset('Skirt.png'),
  tshirt: kidsGirl412Asset('T shirt.png'),
  lehenga: kidsGirl412Asset('Lehenga.png'),
  blouses: kidsGirl412Asset('Blouse.png'),
  'saree-styles': kidsGirl412Asset('Saree.png'),
  blazer: kidsGirl412Asset('blezer.png'),
  hoodies: kidsGirl412Asset('Hoodie.png'),
  layering: kidsGirl412Asset('layering .png'),
  jacket: kidsGirl412Asset('Jacket.png'),
  sweater: kidsGirl412Asset('Hoodie.png'),
  socks: `${process.env.PUBLIC_URL || ''}/assets/womens wear/socks.png`,
};

export function kidsGirlUses412Assets(kidAgeRange) {
  // Kids girl 4–12 uses the same garment thumbnails as teens (12–18) — women's wear icons.
  return false;
}

export function getKidsGirl412GarmentIcon(typeValue) {
  if (!typeValue) return null;
  return KIDS_GIRL_412_ICON_BY_VALUE[typeValue] || null;
}
